import PropTypes from 'prop-types';
import React from 'react';

import AuthorPhoto from './author-photo';
import CompanyLogo from './company-logo';

export const CONTENT_TYPES = {
  'company-logo': CompanyLogo,
  'author-photo': AuthorPhoto,
};

const Item = ({ data, type }) => {
  const Content = CONTENT_TYPES[type] || null;
  return (
    <div className="relative z-10 max-w-[1008px]">
      <p className="text-4xl font-medium leading-tight">{data.text}</p>
      {Content && <Content {...data} />}
    </div>
  );
};

Item.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    author: PropTypes.string,
    logoUrl: PropTypes.string,
    logo: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    authorPhoto: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    authorName: PropTypes.string,
    authorPosition: PropTypes.string,
    readMoreUrl: PropTypes.string,
  }).isRequired,
  type: PropTypes.oneOf(Object.keys(CONTENT_TYPES)).isRequired,
};

export default Item;
